import React, {Fragment, useEffect, useRef, useState} from "react";
import { Col, Row, Table, Collapse, Button, Modal, ModalHeader, ModalBody, ModalFooter, Tooltip, Input } from "reactstrap";
import { getAwsOrgServiceList as onGetAwsOrgServiceList, updateAwsOrgServiceList as onUpdateAwsOrgServiceList } from "../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { getLogo } from "../../helpers/component_helpers";
import Switch from "react-switch";
import DocsTooltip from "components/Common/DocsTooltip";

const OrganizationServices = () => {
    const org_aws_services = useSelector((state) => state.Organization.org_aws_services || []);
    const dispatch = useDispatch();
    const [isOpen, setIsOpen] = useState(true);
    const [serviceStatus, setServiceStatus] = useState({});
    const [autoDeployAlertStatus, setAutoDeployAlertStatus] = useState({});
    const [alcomScoreExclusionStatus, setAlcomScoreExclusionStatus] = useState({});
    const [modalOpen, setModalOpen] = useState(false);
    const [servicesToUpdate, setServicesToUpdate] = useState([]);
    const [ttop, settop] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [filterValues, setFilterValues] = useState({});
    const [orgScanTooltip, setOrgScanTooltip] = useState(false);
    const [initialServiceStatus, setInitialServiceStatus] = useState({});
    const [initialAutoDeployAlertStatus, setInitialAutoDeployAlertStatus] = useState({});
    const [initialAlcomScoreExclusionStatus, setInitialAlcomScoreExclusionStatus] = useState({});
    const [TooltipTop , setTooltipTop] = useState(false);
    const [autoDeployTooltipTop , setAutoDeployTooltipTop] = useState(false);
    const [toggleTooltip, setToggleTooltip] = useState(false);
    const [alcomScoreTooltip, setAlcomScoreTooltiop] = useState(false)
    const [infoTooltip, setInfoTooltip] = useState(false);
    const [queuePrefixTooltip,setQueuePrefixTooltip] = useState(false);

    useEffect(() => {
        dispatch(onGetAwsOrgServiceList());
    }, [dispatch]);

    const toggleCollapse = () => {
        setIsOpen(!isOpen);
    };
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(null);

    const toggle = (index) => {
        setTooltipOpen(!tooltipOpen);
        setCurrentIndex(index);
    };
    const newCurrentIndex = useRef(null);
    const handleMouseOver = (index) => {
        setCurrentIndex(index);
        newCurrentIndex.current = index;
        setTooltipOpen(true);
    };

    const handleMouseOut = () => {
        setTooltipOpen(false);
        newCurrentIndex.current = null;
        setCurrentIndex(null);
    };


    useEffect(() => {
        const initialServiceStatus = {};
        const initialAutoDeployAlertStatus = {};
        const initialAlcomScoreExclusionStatus = {};
        org_aws_services.forEach(service => {
            initialServiceStatus[service.master_resource.name] = service.enabled;
            initialAutoDeployAlertStatus[service.master_resource.name] = service.auto_deploy_alerts;
            initialAlcomScoreExclusionStatus[service.master_resource.name] = service.alcom_exclusion;
        });
        setServiceStatus(initialServiceStatus);
        setAutoDeployAlertStatus(initialAutoDeployAlertStatus);
        setAlcomScoreExclusionStatus(initialAlcomScoreExclusionStatus);
        setInitialServiceStatus(initialServiceStatus);
        setInitialAutoDeployAlertStatus(initialAutoDeployAlertStatus);
        setInitialAlcomScoreExclusionStatus(initialAlcomScoreExclusionStatus);
    }, [org_aws_services]);

    const toggleServiceStatus = (serviceName) => {
        const prevState =serviceStatus[serviceName];
        const newState = !prevState;
        setServiceStatus(prevState => ({
            ...prevState,
            [serviceName]: newState,
        }));

        if (serviceName === "AWS/SQS") {
            if (!servicesToUpdate.includes(serviceName)) {
                setServicesToUpdate(prevState => [...prevState, serviceName]);
            }
        } else {
            if (!servicesToUpdate.includes(serviceName)) {
                setServicesToUpdate(prevState => [...prevState, serviceName]);
            }
        }
        setTimeout(() => {updateServiceStatus(serviceName,newState,'scan_status');}, 300);
    };

    const toggleAutoDeployAlertStatus = (serviceName) => {
        const prevState = autoDeployAlertStatus[serviceName];
        const newState = !prevState;
        setAutoDeployAlertStatus(prevState => ({
            ...prevState,
            [serviceName]: newState,
        }));

        if (!servicesToUpdate.includes(serviceName)) {
            setServicesToUpdate(prevState => [...prevState, serviceName]);
        }
        setTimeout(() => {updateServiceStatus(serviceName,newState,'auto_deploy');}, 300);
    };

    const toggleAlcomScoreExclusionStatus = (serviceName) => {
        const prevState = alcomScoreExclusionStatus[serviceName];
        const newState = !prevState;
        setAlcomScoreExclusionStatus(prevState => ({
            ...prevState,
            [serviceName]: newState,
        }));

        if (!servicesToUpdate.includes(serviceName)) {
            setServicesToUpdate(prevState => [...prevState, serviceName]);
        }
        setTimeout(() => {updateServiceStatus(serviceName,newState,'alcom_score');}, 300);
    }

    const updateServiceStatus = (serviceName,newState,typeofUpdate) => {
        if (typeofUpdate === 'scan_status') {
            if(newState === initialServiceStatus[serviceName] && autoDeployAlertStatus[serviceName] === initialAutoDeployAlertStatus[serviceName]) {
                setServicesToUpdate(prevState => prevState.filter(name => name !== serviceName));
            }
        }else if (typeofUpdate === 'auto_deploy') {
            if (serviceStatus[serviceName] === initialServiceStatus[serviceName] && newState === initialAutoDeployAlertStatus[serviceName]) {
                setServicesToUpdate(prevState => prevState.filter(name => name !== serviceName));
            }
        }else if (typeofUpdate === 'alcom_score') {
            if (serviceStatus[serviceName] === initialServiceStatus[serviceName] && autoDeployAlertStatus[serviceName] === initialAutoDeployAlertStatus[serviceName] && newState === initialAlcomScoreExclusionStatus[serviceName]) {
                setServicesToUpdate(prevState => prevState.filter(name => name !== serviceName));
            }
        }
    }

    const handleFilterChange = (serviceName, value) => {
        setFilterValues(prevState => ({
            ...prevState,
            [serviceName]: value
        }));

        if (!servicesToUpdate.includes(serviceName)) {
            setServicesToUpdate(prevState => [...prevState, serviceName]);
        } else if (serviceName==='AWS/SQS'&& value.trim() === '') {
            setServicesToUpdate(prevState => prevState.filter(name => name !== serviceName));
        }
    };
    const handleUpdate = () => {
        setModalOpen(true);
    };

    const OffSymbol = () => {
        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                    fontSize: 12,
                    color: "#fff",
                    paddingRight: 1
                }}
            >
            </div>
        );
    };

    const OnSymbol = () => {
        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                    fontSize: 12,
                    color: "#fff",
                    paddingRight: 1
                }}
            >
            </div>
        );
    };
    const disabledServicesForAutoDeployment = ['AWS/SQS', 'AWS/EC2'];
    const enabledServicesForAlcomScore = ['AWS/EC2', 'AWS/ECS/Instances']
    const confirmUpdate = () => {
        const payload = servicesToUpdate.map(serviceName => {
            const payloadObj = {
                serviceName,
                status: serviceStatus[serviceName],
                autoDeployAlertStatus: autoDeployAlertStatus[serviceName],
                alcomScoreExclusionStatus: alcomScoreExclusionStatus[serviceName],
            };

            if (serviceName === 'AWS/SQS' && filterValues[serviceName]) {
                payloadObj.filter = filterValues[serviceName];
            }
            if (serviceName === 'AWS/GuardDuty' && filterValues[serviceName]) {
                payloadObj.filter = filterValues[serviceName];
            }

            return payloadObj;
        });
        dispatch(onUpdateAwsOrgServiceList(payload));
        setServicesToUpdate([]);
        setFilterValues({});
        setModalOpen(false);
    };

    const isFilterEmpty = (filter) => {
        try {
            const parsedFilter = JSON.parse(filter);
            return Object.keys(parsedFilter).length === 0;
        } catch (error) {
            console.error('Error parsing filter:', error);
            return true;
        }
    };


    const filteredServices = org_aws_services.filter(service => service.master_resource.name.toLowerCase().includes(searchTerm.toLowerCase()));

    return (
        <Fragment>
            <Row className="full-width" onClick={toggleCollapse}>
                <Col lg={6}>
                        <h5 role="button" className="change-table-text d-flex gap-1 align-items-center">
                            <img src={getLogo('Amazon Web Services')} className="resource-logo" alt='Amazon Web Services' />
                            <span className="text-primary">Amazon Web Services</span>
                            <span id="orgScanTooltip" role="button" className="mt-1">
                            <i className="bx bx-help-circle text-white font-size-16" />
                        </span>
                        </h5>  
                    <DocsTooltip 
                        placement={'right'}
                        isOpen={orgScanTooltip}
                        toggle={()=> setOrgScanTooltip(!orgScanTooltip)}
                        targetId={'orgScanTooltip'}
                        linkText={'Allow list of services for AWS'}
                        link="https://docs.temperstack.com/temperstack/overview/integrating-temperstack-as-the-incident-management-tool#allow-list-of-services-for-aws-organization-scan"
                    />
                </Col>
            </Row>
            <Collapse isOpen={isOpen}>
                <Row>
                    <Col lg={4}>
                        <Input
                            type="text"
                            placeholder="Search by name..."
                            className="bg-transparent mb-4"
                            style={{border: '1px solid whitesmoke'}}
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col lg={8}>
                        <Table className="table-purple-org">
                            <thead>
                            <tr>
                                <th className="text-white">Service Name</th>
                                <th style={{ textAlign: 'center',color:'white' }}>Scan Status</th>
                                <th style={{ textAlign: 'center' ,color:'white'}}>
                                    Auto Deploy Alerts
                                </th>
                                <th style={{ textAlign: 'center',color:'white' }}>
                                    Exclude from Alcom Score
                                </th>
                                <th style={{ textAlign: 'center',color:'white' }}>Filter</th>
                            </tr>
                            </thead>
                            <tbody>
                            {filteredServices.map((service) => (
                                <tr key={service.id} className={"vertical-align-middle text"}>
                                    <td className="text-white">{service.master_resource.name}
                                        {service.master_resource.name === 'AWS/SQS' && (
                                            service.filter === '{}' || service.filter === "\"{}\"" ? (
                                                <div>No Filter</div>
                                            ) : (
                                                <div>
                                                    Queue Name Prefix: {JSON.parse(service.filter).queue_name_prefix}
                                                </div>
                                            )
                                        )}
                                    </td>
                                    <td>
                                        <div style={{display: "flex", justifyContent: "center"}}>
                                            <div
                                                id={`TooltipTop${service.id}`}
                                                onMouseOver={() => handleMouseOver(`TooltipTop${service.id}`)}
                                                onMouseLeave={() => handleMouseOut()}
                                                className="alert-icon"
                                            >
                                                <Switch
                                                    uncheckedIcon={<OffSymbol/>}
                                                    checkedIcon={<OnSymbol/>}
                                                    className="me-1 mb-sm-8 mb-2"
                                                    height={20}
                                                    width={44}
                                                    onColor="#34c38f"
                                                    offColor="#f46a6a"
                                                    boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                                    activeBoxShadow="0px 0px 1px 5px"
                                                    onChange={() => toggleServiceStatus(service.master_resource.name)}
                                                    checked={serviceStatus[service.master_resource.name] || false}
                                                    disabled={(service.master_resource.name === 'AWS/SQS' && isFilterEmpty(service.filter) && !filterValues['AWS/SQS'])}
                                                />
                                            </div>
                                            <Tooltip
                                                placement="top"
                                                isOpen={tooltipOpen && newCurrentIndex.current ===`TooltipTop${service.id}`}
                                                target={`TooltipTop${service.id}`}
                                                toggle={() => toggle(`TooltipTop${service.id}`)}
                                                style={{
                                                    border: "2px solid #f1b44c",
                                                    borderRadius: "10px",
                                                    backgroundColor: "#2a3042",
                                                    zIndex: 1,
                                                    minWidth: "100%",
                                                    textAlign: "center",
                                                    marginBottom: "1px",
                                                }}
                                                className={"fix-flicker"}
                                            >
                                                Enable/Disable Service for scan
                                            </Tooltip>
                                        </div>
                                    </td>
                                    <td>
                                        <div style={{textAlign: 'center'}}>
                                            <div
                                                id={`auto_deploy_TooltipTop${service.id}`}
                                                onMouseOver={() => handleMouseOver(`auto_deploy_TooltipTop${service.id}`)}
                                                onMouseLeave={() => handleMouseOut()}
                                                className="alert-icon"
                                            >
                                                <Switch
                                                    uncheckedIcon={<OffSymbol/>}
                                                    checkedIcon={<OnSymbol/>}
                                                    className="me-1 mb-sm-8 mb-2"
                                                    height={20}
                                                    width={44}
                                                    onColor="#34c38f"
                                                    offColor="#f46a6a"
                                                    boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                                    activeBoxShadow="0px 0px 1px 5px"
                                                    onChange={() => toggleAutoDeployAlertStatus(service.master_resource.name)}
                                                    checked={autoDeployAlertStatus[service.master_resource.name] || false}
                                                    disabled={disabledServicesForAutoDeployment.includes(service.master_resource.name)}
                                                />
                                            </div>
                                            <Tooltip
                                                placement="top"
                                                isOpen={tooltipOpen && newCurrentIndex.current ===`auto_deploy_TooltipTop${service.id}`}
                                                target={`auto_deploy_TooltipTop${service.id}`}
                                                toggle={() => toggle(`auto_deploy_TooltipTop${service.id}`)}
                                                className={"fix-flicker"}
                                                style={{
                                                    border: "2px solid #f1b44c",
                                                    borderRadius: "10px",
                                                    backgroundColor: "#2a3042",
                                                    zIndex: 1,
                                                    minWidth: "100%",
                                                    textAlign: "center",
                                                    marginBottom: "1px",
                                                }}
                                            >
                                                Enable/Disable Auto Deploy Alerts
                                            </Tooltip>
                                        </div>
                                    </td>
                                    <td>
                                        {(service.master_resource.name === 'AWS/EC2' || service.master_resource.name === 'AWS/ECS/Instances') && (
                                            <div style={{textAlign: 'center'}}>
                                                <div className="d-flex justify-content-center align-items-center">
                                                    <div
                                                        id="alcomscoretooltip"
                                                        onMouseOver={() => setAlcomScoreTooltiop(true)}
                                                        onMouseLeave={() => setAlcomScoreTooltiop(false)}
                                                        className="alert-icon"
                                                    >
                                                        <Switch
                                                            uncheckedIcon={<OffSymbol/>}
                                                            checkedIcon={<OnSymbol/>}
                                                            className="me-1 mb-sm-8 mb-2"
                                                            height={20}
                                                            width={44}
                                                            onColor="#34c38f"
                                                            offColor="#f46a6a"
                                                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                                            activeBoxShadow="0px 0px 1px 5px"
                                                            onChange={() => toggleAlcomScoreExclusionStatus(service.master_resource.name)}
                                                            checked={alcomScoreExclusionStatus[service.master_resource.name] || false}
                                                            disabled={!enabledServicesForAlcomScore.includes(service.master_resource.name)}
                                                        />
                                                    </div>
                                                    <span
                                                        role="button"
                                                        className="ms-2 mb-2"
                                                        onMouseOver={() => setInfoTooltip(true)}
                                                        onMouseLeave={() => setInfoTooltip(false)}
                                                    >
                                                        <i id="infoTooltip"
                                                           className="mdi mdi-information-outline font-size-18 text-success"/>
                                                    </span>
                                                </div>
                                                <Tooltip
                                                    placement="top"
                                                    isOpen={alcomScoreTooltip}
                                                    target="alcomscoretooltip"
                                                    toggle={() => setAlcomScoreTooltiop(!alcomScoreTooltip)}
                                                    className={"fix-flicker"}
                                                    style={{
                                                        border: "2px solid #f1b44c",
                                                        borderRadius: "10px",
                                                        backgroundColor: "#2a3042",
                                                        zIndex: 1,
                                                        minWidth: "100%",
                                                        textAlign: "center",
                                                        marginBottom: "1px",
                                                    }}
                                                >
                                                    Enable/Disable Alcom Score
                                                </Tooltip>

                                                <Tooltip
                                                    target={'infoTooltip'}
                                                    isOpen={infoTooltip}
                                                    toggle={() => setInfoTooltip(!infoTooltip)}
                                                    placement={'top'}
                                                    className={'fix-flicker'}
                                                    style={{
                                                        border: '2px solid #f1b44c',
                                                        borderRadius: '10px',
                                                        backgroundColor: '#2a3042',
                                                        zIndex: 1,
                                                        minWidth: '100%',
                                                        textAlign: 'center',
                                                        marginBottom: '1px'
                                                    }}>
                                                    <span className="font-size-12 text-start mb-5">
                                                      Only auto-scaled instances will be ignored, not individual instances
                                                    </span>
                                                </Tooltip>
                                            </div>
                                        )}
                                    </td>
                                    <td>
                                        {service.master_resource.name === 'AWS/SQS' && (
                                            <div className="d-flex align-items-center gap-2">
                                            <Input
                                                type="text"
                                                className="bg-transparent"
                                                placeholder="Enter Queue Prefix"
                                                value={filterValues[service.master_resource.name] || ''}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    handleFilterChange(service.master_resource.name, value);
                                                    const prefixes = value.split(',').map(prefix => prefix.trim());
                                                    const isValid = prefixes.every(prefix =>
                                                        prefix === '' ||
                                                        (prefix.length >= 3 && /^[a-zA-Z0-9_-]+$/.test(prefix))
                                                    );
                                                }}
                                            />
                                            <i
                                                className="bx bx-info-circle font-size-16"
                                                id="queuePrefixTooltip"
                                                style={{ cursor: 'pointer' }}
                                            />
                                            <Tooltip
                                                target="queuePrefixTooltip"
                                                isOpen={queuePrefixTooltip}
                                                toggle={() => setQueuePrefixTooltip(!queuePrefixTooltip)}
                                                placement="top"
                                                style={{
                                                    border: '2px solid #f1b44c',
                                                    borderRadius: '10px',
                                                    backgroundColor: '#2a3042',
                                                    zIndex: 1,
                                                    minWidth: '100%',
                                                    textAlign: 'center',
                                                    marginBottom: '1px'
                                                }}
                                            >
                                                <span className="font-size-12 text-start mb-5">
                                                    Filter SQS queues by entering one or more queue name prefixes separated by commas (e.g. prod-,dev-)
                                                </span>
                                            </Tooltip>
                                        </div>
                                        )}
                                        {service.master_resource.name === 'AWS/GuardDuty' && (
                                            <Input
                                                type="text"
                                                className="bg-transparent"
                                                placeholder="Event bus name to deploy alerts ..."
                                                minLength="3"
                                                value={
                                                    filterValues[service.master_resource.name] !== undefined
                                                        ? filterValues[service.master_resource.name]
                                                        : JSON.parse(service.filter).event_bus_name || ''
                                                }
                                                onChange={(e) => handleFilterChange(service.master_resource.name, e.target.value)}
                                            />
                                        )}
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
                <Row className="mt-3">
                    <Col lg={{size: 9, offset: 6}} className="text-right">
                        <Button color="primary" onClick={handleUpdate} disabled={servicesToUpdate.length === 0}>Update
                            Status</Button>
                    </Col>
                </Row>
            </Collapse>
            <Modal isOpen={modalOpen} toggle={() => setModalOpen(false)}
                   size='lg'>
                <ModalHeader toggle={() => setModalOpen(false)}>Confirm Update</ModalHeader>
                <ModalBody>
                    <div>
                        <div className="row">
                            <div className="col-md-4"><b>Service Name</b></div>
                            <div className="col-md-2"><b>Service Status</b></div>
                            <div className="col-md-2"><b>Auto Deploy Alert Status</b></div>
                            <div className="col-md-2"><b>Exclude from Alcom Score</b></div>
                            <div className="col-md-2"><b>Filter</b></div>
                        </div>
                        {servicesToUpdate.map(serviceName => (
                            <div key={serviceName} className="row mt-2">
                                <div className="col-md-4">{serviceName}</div>
                                <div className="col-md-2">{serviceStatus[serviceName] ? 'Enabled' : 'Disabled'}</div>
                                <div
                                    className="col-md-2">{autoDeployAlertStatus[serviceName] ? 'Enabled' : 'Disabled'}</div>
                                <div
                                    className="col-md-2">{alcomScoreExclusionStatus[serviceName] ? 'Enabled' : 'Disabled'}</div>
                                <div className="col-md-2">{filterValues[serviceName]}</div>
                            </div>
                        ))}
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={confirmUpdate}>Confirm Update</Button>{' '}
                    <Button color="secondary" onClick={() => setModalOpen(false)}>Cancel</Button>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
};

export default OrganizationServices;
